import { useIsClient } from "@/hooks/useIsClient";
import { useAuthStore } from "../stores/authStore";
import { isAuthed } from "../models/authState";

/**
 * Check if user is logged in
 * Returns false during SSR to prevent hydration mismatches
 */
export const useIsLoggedIn = (): boolean => {
  const isLoggedIn = useAuthStore((s) => isAuthed(s));
  const isClient = useIsClient();

  // Make sure we are never logged in before the first mount
  return isClient ? isLoggedIn : false;
};
